import { defineMessages } from "react-intl"

export const messages = defineMessages({
  browserSupport: {
    id: "notification.browserSupport",
    defaultMessage: "Sorry, your browser does not fully support this website. Please update it to the latest version or use a different browser if on Internet Explorer."
  },
})

export default messages



// WEBPACK FOOTER //
// ./webapp/messages/notification.js